import { Dialog } from '@/components/UI/Dialog'
import type { MynaviNearbyOpenCampusItem } from '@/schemas/v2/mynavi'
import { MYNAVI_PRIMARY } from '../Color'
import { MyNaviTypography } from '../MyNaviUI/MyNaviTypography'

export type MyNaviNearbyOcDialogProps = {
  isOpen: boolean
  onClose: () => void
  openCampuses: MynaviNearbyOpenCampusItem[]
  onSelect: (oc: MynaviNearbyOpenCampusItem) => void
}

export const MyNaviNearbyOcDialog = ({ isOpen, onClose, openCampuses, onSelect }: MyNaviNearbyOcDialogProps) => {
  return (
    <Dialog selectorState={isOpen} closeFunc={onClose} showCloseButton>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '8px 0 16px',
        }}
      >
        {/* タイトル */}
        <MyNaviTypography
          variant="large-title"
          as="p"
          className="text-center leading-[1.4] mb-[20px] whitespace-pre-wrap"
          style={{ color: MYNAVI_PRIMARY }}
        >
          {'参加している\nオープンキャンパスを\n選択してください'}
        </MyNaviTypography>

        {/* OC リスト（バックエンドの返却順序を保持） */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {openCampuses.map((oc, index) => (
            <div key={oc.id}>
              {/* 区切り線（最初のアイテム以外） */}
              {index > 0 && (
                <div
                  style={{
                    height: '1px',
                    backgroundColor: '#cccccc',
                    margin: '0 0',
                  }}
                />
              )}
              {/* アイテム行 */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '12px 0',
                  gap: '10px',
                }}
              >
                {/* 大学名 + キャンパス名（上段・左寄せ） */}
                <MyNaviTypography variant="heading" className="leading-[1.4] m-0">
                  {oc.college.name}
                  {oc.campus.name ? ` ${oc.campus.name}` : ''}
                </MyNaviTypography>

                {/* 参加しているボタン（下段・右寄せ） */}
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <button
                    type="button"
                    onClick={() => onSelect(oc)}
                    style={{
                      backgroundColor: MYNAVI_PRIMARY,
                      color: '#ffffff',
                      fontSize: '12px',
                      fontWeight: 400,
                      fontFamily: "'BIZ UDPGothic', sans-serif",
                      border: 'none',
                      borderRadius: 0,
                      height: '39px',
                      width: '109px',
                      flexShrink: 0,
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    参加している
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 閉じるボタン */}
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              backgroundColor: '#ffffff',
              color: MYNAVI_PRIMARY,
              fontSize: '15px',
              fontWeight: 400,
              fontFamily: "'BIZ UDPGothic', sans-serif",
              border: `1px solid ${MYNAVI_PRIMARY}`,
              borderRadius: 0,
              height: '39px',
              width: '245px',
              cursor: 'pointer',
            }}
          >
            閉じる
          </button>
        </div>
      </div>
    </Dialog>
  )
}
